<template>
  <div class="news-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem to="/news">资讯</shBreadItem>
    </shBread>
  </div>
  <div class="news">
    <div class="sh-topnews">
      <div class="left-news">
        <NewsgoLogin />

        <div class="left-news-bottom">
          <NewsLink />
        </div>
      </div>
      <!-- 轮播图 -->
      <div class="middle-news">
        <Transition name="fade">
          <div v-if="sliders.length" class="slider">
            <!-- <ShCarousel auto-play :sliders="sliders" /> -->
            <el-carousel height="180px" :interval="5000">
              <el-carousel-item v-for="item in sliders" :key="item._id">
                <RouterLink target="_blank" :to="`${item.bannerUrl}`">
                  <img
                    style="width: 100vw; height: 500px"
                    v-lazy="item.bannerImg"
                    alt=""
                  />
                </RouterLink>
              </el-carousel-item>
            </el-carousel>
          </div>
          <ShCarouselSkeleton v-else />
        </Transition>

        <div class="news-list">
          <NewsList />
        </div>
      </div>
      <div class="right-news">
        <div class="listen">
          <div class="top">
            <div class="left">
              <i></i>
              <RouterLink target="_blank" to="/video"
                ><h3>课程试听</h3>
              </RouterLink>
            </div>
            <div class="right">
              <RouterLink target="_blank" to="/video"
                ><span>更多</span>
                <el-icon><ArrowRight /></el-icon>
              </RouterLink>
            </div>
          </div>
          <TeachDesc />
          <div class="livevideo">
            <TimeLine />
          </div>
        </div>
      </div>
    </div>

    <div class="adv">
      <RouterLink target="_blank" to="/video?maID=ma055618&firstCate=198">
        <img
          src="../../../public/imgs/news-横幅广告-25年职称辅导课.jpg"
          alt="山河医学网25年职称辅导课"
        />
      </RouterLink>
    </div>
    <ZhiYeNews />
    <ChuJiNews />
    <ZhongJiNews />
    <FuGaoNews />
    <ZhengGaoNews />
    <OtherNews />
  </div>
</template>

<script>
import ShCarouselSkeleton from "./compontents/common/shcarousel-skeleton.vue";

import NewsList from "./compontents/common/news-list.vue";
import ZhiYeNews from "./compontents/zhiyenews.vue";
import ChuJiNews from "./compontents/chujinews.vue";
import ZhongJiNews from "./compontents/zhongjinews.vue";
import FuGaoNews from "./compontents/fugaonews.vue";
import ZhengGaoNews from "./compontents/zhenggaonews.vue";
import OtherNews from "./compontents/othernews.vue";
import TimeLine from "./compontents/common/TimeLine.vue";
import TeachDesc from "./compontents/common/teach-desc.vue";
import NewsLink from "./compontents/common/news-link.vue";
import NewsgoLogin from "./compontents/common/news-gologin.vue";
import { useRoute, useRouter } from "vue-router";
import { findBanner } from "@/api/home";
import { ref } from "vue";
import { ElMessage } from "element-plus";
//import { orderStatus } from "@/api/constants";
export default {
  name: "News",
  components: {
    NewsList,
    ZhongJiNews,
    ZhiYeNews,
    ChuJiNews,
    FuGaoNews,
    ZhengGaoNews,
    OtherNews,
    NewsLink,
    TimeLine,
    TeachDesc,
    NewsgoLogin,
    ShCarouselSkeleton,
  },
  setup() {
    const router = useRouter();

    const sliders = ref([]);
    findBanner(1719395117223)
      .then((data) => {
        sliders.value = data;
      })
      .catch((error) => {
        ElMessage({
          message: error.message,
          type: "error",
          plain: true,
        });
      });
    return { sliders };
  },
};
</script>

<style lang="less">
.news-bread {
  background: @shColor;
  margin-bottom: 15px;
}

.news {
  width: 1240px;
  margin: 0 auto;
  .sh-topnews {
    margin-top: 20px;
    height: 600px;
    display: flex;
    justify-content: space-between;
    .left-news {
      width: 250px;
      background: #ffffff;

      .left-news-bottom {
        display: flex;
        flex-direction: column;
        height: 350px;
        margin-left: 25px;
        margin-top: 15px;
      }
    }
    .middle-news {
      position: relative;
      overflow: hidden;
      background: #ffffff;
      height: 600px;
      .slider {
        width: 700px;
        height: 180px;

        .sh-carousel {
          width: 100%;
          height: 100%;
          min-width: 300px;
          min-height: 150px;
          position: relative;
          .carousel {
            &-body {
              width: 100%;
              height: 100%;
            }
            &-item {
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;
              opacity: 0;
              transition: opacity 0.5s linear;
              &.fade {
                opacity: 1;
                z-index: 1;
              }
              img {
                width: 100%;
                height: 100%;
                border-radius: 8px;
              }
            }
            &-indicator {
              position: absolute;
              left: 0;
              bottom: 5px;
              z-index: 2;
              width: 100%;
              text-align: center;
              span {
                display: inline-block;
                width: 12px;
                height: 12px;
                background: rgba(0, 0, 0, 0.2);
                border-radius: 50%;
                cursor: pointer;
                ~ span {
                  margin-left: 12px;
                }
                &.active {
                  background: @shColor;
                }
              }
            }
            &-btn {
              width: 44px;
              height: 44px;
              background: rgba(0, 0, 0, 0.2);
              color: #fff;
              border-radius: 50%;
              position: absolute;
              top: 68px;
              z-index: 2;
              text-align: center;
              line-height: 44px;
              opacity: 0;
              transition: all 0.5s;
              &.prev {
                left: 20px;
              }
              &.next {
                right: 20px;
              }
            }
          }
          &:hover {
            .carousel-btn {
              opacity: 1;
            }
          }
        }
      }

      .sh-carousel {
        ::v-deep .carousel-btn.prev {
          left: 170px;
          background: #000;
        }
        ::v-deep .carousel-indicator {
          padding-left: 250px;
        }
      }
      .news-list {
        margin-top: 20px;
      }
    }
    .right-news {
      width: 250px;
      background: #ffffff;
      .listen {
        height: 210px;
        .top {
          display: flex;
          height: 50px;
          align-items: center;
          justify-content: space-between;
          .left {
            display: flex;
            i {
              display: inline-block;
              width: 3px;
              height: 20px;
              background: @shColor;
            }
            h3 {
              padding-left: 15px;
              &:hover {
                color: @shColor;
              }
            }
          }

          .right {
            :hover {
              color: @shColor;
            }
            a {
              margin-right: 5px;
              display: flex;
              align-items: center;
              color: #999;
            }
          }
        }

        .livevideo {
          height: 280px;
          .text {
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left {
              display: flex;
              align-items: center;
              a {
                h3 {
                  padding-left: 15px;
                  &:hover {
                    color: @shColor;
                  }
                }
              }
              i {
                display: inline-block;
                width: 3px;
                height: 18px;
                background: @shColor;
              }
            }
            .right {
              :hover {
                color: @shColor;
              }
              a {
                color: #999;
                display: flex;
                align-items: center;
              }
            }
          }
        }
      }
    }
  }
  .adv {
    margin-top: 30px;
    height: 120px;
    background: #666;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
